import React, { useEffect, useState } from 'react'
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import logo from "../images/cargosailor_logo.png";

import { requestServer } from '../services/request.js';
import { useHistory } from 'react-router-dom';

const Input = tw.input`w-full mb-4 border border-gray-400 px-4 py-3 focus:outline-none font-medium transition duration-300 hocus:border-orange-500`
const Sinput = tw.input`mb-4 border border-gray-400 px-4 py-3 focus:outline-none font-medium transition duration-300 hocus:border-orange-500`

const AdminBoard = () => {
    const [tb, setTb] = useState([])
    const [ser, setSer] = useState("fedex")
    const [showModal, setShowModal] = useState(false);

    let history = useHistory()

    const onMount = () => {
        let load = {
            "api_name" : "getOrderDetails",
            "data" : {
                "serviceprovider": ser
            }
        }

        requestServer(load).then((res) => {
            // setProcess(true)
            console.log(res.data.data);
            setTb(res.data.data)
        }).catch((err) => {
            // setProcess(true)
            console.log(err)
        })
    }
    useEffect(() => {
        onMount()
    }, [ser])

    const [fd, setFd] = useState({
        "id": "",
        "isWalking": false,
        "volumetricParam": {
            "l": "",
            "w": "",
            "h": ""
        },
        "volumetricWeight": "",
        "weight": "",
        "mode": "",
        "sector": "",
        "razorpaySignature": "",
        "paymentcontact": "",
        "vpa": "",
        "wallet": "",
        "bank": "",
        "card_id": "",
        "description": "",
        "method": "",
        "trackingnumber": "",
        "orderstatus": "",
        "paymentId": "",
        "razorpayOrderId": "",
        "orderedAt": "",
        "packagesize": "",
        "isdocument": "",
        "countryname": "",
        "status": "",
        "serviceprovider": "",
        "amount": null,
        "address": "",
        "email": "",
        "contact": "",
        "customername": ""
    })

    const updateNow = (id) => {
      let load = {
          "api_name" : "updateOrderDetails",
          "data" : {
            "id": id,
            "updates": fd
          }
      }

      requestServer(load).then((res) => {
          // setProcess(true)
          console.log(res.data);
          onMount();
          setShowModal(false);
      }).catch((err) => {
          // setProcess(true)
          console.log(err)
      })
    }

    return (
    <>
        <div tw="shadow-lg rounded p-5 m-5 min-h-full">
        <div tw="flex p-5 items-center shadow rounded my-5 justify-between">
          <div tw="flex items-center">
            <img src={logo} tw="w-8" />
            <p tw="px-4">Dashboard</p>
          </div>
          <div tw="bg-red-600 px-4 py-2 text-white rounded cursor-pointer font-bold" onClick={() => history.push("/admin-login")}>
            Logout
          </div>
        </div>
        <div tw="grid gap-1 grid-cols-4">
            <div css={[tw`text-sm bg-orange-100 hover:bg-orange-400 mb-4 rounded px-3 py-3 font-bold cursor-pointer`, ser==="fedex" && tw`bg-orange-400`]} onClick={() => setSer("fedex")}>FedEx</div>
            <div css={[tw`text-sm bg-orange-100 hover:bg-orange-400 mb-4 rounded px-3 py-3 font-bold cursor-pointer`, ser==="dhl" && tw`bg-orange-400`]} onClick={() => setSer("dhl")}>DHL</div>
            <div css={[tw`text-sm bg-orange-100 hover:bg-orange-400 mb-4 rounded px-3 py-3 font-bold cursor-pointer`, ser==="ups" && tw`bg-orange-400`]} onClick={() => setSer("ups")}>UPS</div>
            <div css={[tw`text-sm bg-orange-100 hover:bg-orange-400 mb-4 rounded px-3 py-3 font-bold cursor-pointer`, ser==="domestic" && tw`bg-orange-400`]} onClick={() => setSer("domestic")}>Domestic</div>
        </div>
        <div tw="overflow-x-auto rounded">
            <table tw='border-collapse table-auto w-full whitespace-no-wrap bg-white table-auto relative'>
                <thead>
                    <tr tw='text-left '>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>Name</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>Contact</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>Email</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>isWalking</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>volumetricParam</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>volumetricWeight</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>weight</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>mode</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>sector</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>razorpaySignature</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>paymentcontact</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>vpa</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>wallet</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>bank</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>card_id</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>description</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>method</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>trackingnumber</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>orderstatus</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>packagesize</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>isdocument</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>countryname</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>status</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>serviceprovider</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>amount</th>
                        <th tw='py-2 px-3 sticky top-0 border bg-orange-400 border-white border-4'>address</th>
                    </tr>
                </thead>
                <tbody tw="bg-orange-100">
                    {tb && tb.map((dt, i) => 
                        <tr key={i} tw='text-left cursor-pointer hover:bg-orange-200' onClick={() => {setShowModal(true); setFd(prev => ({...prev, id: dt._id, isWalking: dt.isWalking, customername: dt.customername, contact: dt.contact, email: dt.email, address: dt.address, amount: dt.amount, serviceprovider: dt.serviceprovider, status: dt.status, countryname: dt.countryname, isdocument: dt.isdocument, packagesize: dt.packagesize, orderedAt: dt.orderedAt, razorpayOrderId: dt.razorpayOrderId, paymentId: dt.paymentId, orderstatus: dt.orderstatus, trackingnumber: dt.trackingnumber, method: dt.method, description: dt.description, card_id: dt.card_id, bank: dt.bank, wallet: dt.wallet, vpa: dt.vpa, paymentcontact: dt.paymentcontact, razorpaySignature: dt.razorpaySignature, sector: dt.sector, mode: dt.mode, weight: dt.weight, volumetricWeight: dt.volumetricWeight, volumetricParam: {"l": dt.volumetricParam?.l | "", "w": dt.volumetricParam?.w | "", "h": dt.volumetricParam?.h | ""}}));}}>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.customername}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.contact}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.email}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.isWalking ? "Yes" : "No"}</td>
                           { dt.volumetricParam ? <td tw='border px-3 py-3 border-white border-4'>{dt.volumetricParam.l}, {dt.volumetricParam.w}, {dt.volumetricParam.h}</td> : <td tw='border px-3 py-3 border-white border-4'></td>}
                            <td tw='border px-3 py-3 border-white border-4'>{dt.volumetricWeight}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.weight}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.mode}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.sector}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.razorpaySignature}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.paymentcontact}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.vpa}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.wallet}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.bank}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.card_id}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.description}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.method}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.trackingnumber}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.orderstatus}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.packagesize}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.isdocument}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.countryname}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.status}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.serviceprovider}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.amount}</td>
                            <td tw='border px-3 py-3 border-white border-4'>{dt.address}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        </div>

    {showModal && (
    <>
      <div
        tw="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
      >
        <div tw="relative w-auto mb-6 mx-auto max-w-3xl" style={{marginTop: "130rem"}}>
          {/*content*/}
          <div tw="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
            {/*header*/}
            <div tw="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t">
              <h3 tw="text-3xl font-semibold">
                Update Details
              </h3>
              <button
                tw="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                onClick={() => setShowModal(false)}
              >
                <span tw="bg-transparent text-black h-8 w-8 text-2xl block outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div tw="relative p-6 flex-auto">
                <label>customername</label>
                <Input type="text" value={fd.customername} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, customername: ch}));}}/>
                <label>Email</label>
                <Input type="text" value={fd.email} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, email: ch}));}}/>
                <label>Contact</label>
                <Input type="text" value={fd.contact} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, contact: ch}));}}/>
                <label 
                  htmlFor="toogleA"
                  tw="flex items-center cursor-pointer mb-5 px-3 py-4 border border-gray-400"
                >
                  <div tw="relative">
                    <input id="toogleA" type="checkbox" tw="hidden" checked={fd.isWalking} value={fd.isWalking} onChange={(e) => {setFd(prev => ({...prev, isWalking: !fd.isWalking}));}} />
                    <div
                    className="toggle__line"
                      tw="w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    ></div>
                    <div
                    className="toggle__dot"
                      tw="absolute w-6 h-6 bg-white rounded-full shadow"
                    ></div>
                  </div>
                  <div
                    tw="ml-3 font-medium"
                  >
                    isWalking
                  </div>
                </label>
                <label>volumetricParam</label><br/>
                <div tw="grid gap-2 grid-cols-3">
                <Sinput type="text" value={fd.volumetricParam?.l} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, volumetricParam: {...prev.volumetricParam, "l": ch}}));}}/>
                <Sinput type="text" value={fd.volumetricParam?.w} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, volumetricParam: {...prev.volumetricParam, "w": ch}}));}}/>
                <Sinput type="text" value={fd.volumetricParam?.h} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, volumetricParam: {...prev.volumetricParam, "h": ch}}));}}/>
                </div>

                <label>volumetricWeight</label>
                <Input type="text" value={fd.volumetricWeight} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, volumetricWeight: ch}));}} />
                <label>weight</label>
                <Input type="text" value={fd.weight} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, weight: ch}));}} />
                <label>mode</label>
                <Input type="text" value={fd.mode} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, mode: ch}));}} />
                <label>sector</label>
                <Input type="text" value={fd.sector} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, sector: ch}));}} />
                <label>razorpaySignature</label>
                <Input type="text" value={fd.razorpaySignature} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, razorpaySignature: ch}));}} />
                <label>paymentcontact</label>
                <Input type="text" value={fd.paymentcontact} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, paymentcontact: ch}));}} />
                <label>vpa</label>
                <Input type="text" value={fd.vpa} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, vpa: ch}));}} />
                <label>wallet</label>
                <Input type="text" value={fd.wallet} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, wallet: ch}));}} />
                <label>bank</label>
                <Input type="text" value={fd.bank} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, bank: ch}));}} />
                <label>card_id</label>
                <Input type="text" value={fd.card_id} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, card_id: ch}));}} />
                <label>description</label>
                <Input type="text" value={fd.description} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, description: ch}));}} />
                <label>method</label>
                <Input type="text" value={fd.method} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, method: ch}));}} />
                <label>trackingnumber</label>
                <Input type="text" value={fd.trackingnumber} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, trackingnumber: ch}));}} />
                <label>orderstatus</label>
                <Input type="text" value={fd.orderstatus} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, orderstatus: ch}));}} />
                <label>paymentId</label>
                <Input type="text" value={fd.paymentId} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, paymentId: ch}));}} />
                <label>razorpayOrderId</label>
                <Input type="text" value={fd.razorpayOrderId} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, razorpayOrderId: ch}));}} />
                <label>orderedAt</label>
                <Input type="text" value={fd.orderedAt} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, orderedAt: ch}));}} />
                <label>packagesize</label>
                <Input type="text" value={fd.packagesize} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, packagesize: ch}));}} />
                <label>isdocument</label>
                <Input type="text" value={fd.isdocument} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, isdocument: ch}));}} />
                <label>countryname</label>
                <Input type="text" value={fd.countryname} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, countryname: ch}));}} />
                <label>status</label>
                <Input type="text" value={fd.status} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, status: ch}));}} />
                <label>serviceprovider</label>
                <Input type="text" value={fd.serviceprovider} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, serviceprovider: ch}));}} />
                <label>amount</label>
                <Input type="text" value={fd.amount} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, amount: ch}));}} />
                <label>address</label>
                <Input type="text" value={fd.address} onChange={(e) => {let ch = e.target.value; setFd(prev => ({...prev, address: ch}));}} />
            </div>
            {/*footer*/}
            <div tw="flex items-center justify-end p-6 border-t border-solid border-gray-300 rounded-b">
              <button
                tw="text-red-500 bg-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                type="button"
                style={{ transition: "all .15s ease" }}
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button
                tw="bg-green-500 text-white active:bg-green-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                type="button"
                style={{ transition: "all .15s ease" }}
                onClick={() => updateNow(fd.id)}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div tw="opacity-25 fixed inset-0 z-40 bg-black" onClick={() => setShowModal(false)}></div>
      </>
      )}
      </>
    )
}

export default AdminBoard
